import { CompanyRequestDto } from "../dtos/CompanyRequestDto";
import { InfiniteScrollHelper, ResponseCallback } from "../libs/infinite-scroll-helper";
import { IResponse, IResponseWithData, RequestType } from "../libs/request-helper";
import { JobOfferEntryDto } from "../dtos/JobOfferEntryDto";
import { PublicCompanyPageRenderer } from "../renderer/PublicCompanyPageRenderer";
import { CompanyGeneralInformationResponseDto } from "../dtos/CompanyGeneralInformationResponseDto";


declare var BASE_URL: any;
declare var API_VERSION: any;
declare var JOB_GIVER_GENERAL_DATA: IResponseWithData<CompanyGeneralInformationResponseDto>;
export class Company implements ResponseCallback {
    protected static REQUEST_URL = "api/" + API_VERSION + "/PublicData/GetPublicCompanyJobOfferInfos/";
    protected static ERROR_MSG = "Es konnten leider keine Jobs gefunden werden!";
    protected dataContainer: HTMLElement;
    public request: CompanyRequestDto;
    protected companyRenderer: PublicCompanyPageRenderer;
    public scrollHelper : InfiniteScrollHelper;
    private static EMPLOYMENT_TYPE_FILTER_SEARCH_QUERY_KEY = "jobs";
    private static EmploymentTypeFilter: {[key: string]: number} = {
        "ft": 1,
        "pt": 2,
        "a" : 4,
    }
    protected showFilter : Boolean = false;


    protected static async init(): Promise<void> {
        document.addEventListener('DOMContentLoaded', Company.onDocumentLoaded, false);
    }

    constructor() {
        this.dataContainer = <HTMLElement>document.getElementById("jobsContainer");
        this.companyRenderer = new PublicCompanyPageRenderer(this.dataContainer, Company.ERROR_MSG, this);
        const currentPath = window.location.pathname;
        const pathParts = currentPath.split("/");
        const id = pathParts[pathParts.indexOf("u") + 1];

        this.request = { name: id, pageNumber: 0, EmploymentTypeFilter: 0 };
        const queryString = window.location.search;
        if(queryString) {
            const urlParams = new URLSearchParams(queryString);
            const employmentTypeFilterKey = urlParams.get(Company.EMPLOYMENT_TYPE_FILTER_SEARCH_QUERY_KEY);
            if(Company.EmploymentTypeFilter[employmentTypeFilterKey]) {
                this.request.EmploymentTypeFilter = Company.EmploymentTypeFilter[employmentTypeFilterKey];
            }
        }

        this.scrollHelper = new InfiniteScrollHelper(
            this.dataContainer,
            this,
            this.request,
            BASE_URL + Company.REQUEST_URL,
            RequestType.COMPANY_PAGE,
            window
        );
        var responseGeneralData = <CompanyGeneralInformationResponseDto>JOB_GIVER_GENERAL_DATA.data;
        if(responseGeneralData) {
            this.companyRenderer.renderGeneralInfo(responseGeneralData);
        }

    }

    protected static onDocumentLoaded() {
        const instance = new Company();
    }

    public responseCallback(res: IResponse): boolean {
        if (res.requestError) {
            this.companyRenderer.renderError()
            return false
        }

        var response = <IResponseWithData<JobOfferEntryDto[]>>res;
        var jobOffers = response.data;

        //check if new data was available
        if (jobOffers.length > 0) {
            this.request.pageNumber += 1;
            //Render JobOffers Items
            this.scrollHelper.setRequestDto<CompanyRequestDto>(this.request);
            for (var i = 0; i < jobOffers.length; i++) {
                this.companyRenderer.renderJobOffer(jobOffers[i]);
            }
            return true;
        } else {
            return false;
        }
    }

    
}